// extracted by mini-css-extract-plugin
export default {"wrapper":"IsolationHeader_wrapper__t+rU4","description":"IsolationHeader_description__5HDxz","userFlowLabel":"IsolationHeader_userFlowLabel__+N299"};